<template>
    <vx-card title="Emergency PO Return Stock Movement">
        <div class="flex md:flex-row">
            <div class="w-full pr-6 md:basis-1/2">
                <h4>Document Details</h4>
                <hr>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>PO Return Document</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <vs-input
                            type="text"
                            v-model="code"
                            class="w-full"
                        />
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Outbound Document</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <vs-input
                            type="text"
                            v-model="outboundCode"
                            class="w-full"
                        />
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Supplier return type</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <v-select
                            :filterable="true"
                            :options="returnType"
                            v-model="selectedReturnType"
                            label="name"
                            :clearable="false"
                        />
                    </div>
                </div>
                <div class="mb-6 vx-row pt-2">
                    <div class="flex items-center w-full vx-col sm:w-1/3">
                        <span>Movement Operation</span>
                    </div>
                    <div class="w-full vx-col sm:w-2/3">
                        <vs-input
                            type="text"
                            v-model="movementOperation"
                            class="w-full"
                        />
                    </div>
                </div>
            </div>
            <div class="w-full md:basis-1/2">
                <div class="w-full pr-6 md:basis-1/2">
                    <h4>Key Password</h4>
                    <hr>
                    <div class="mb-6 vx-row pt-2">
                        <div class="flex items-center w-full vx-col sm:w-1/3">
                            <span>Input Password</span>
                        </div>
                        <div class="w-full vx-col sm:w-2/3">
                            <vs-input
                                type="text"
                                v-model="thePassword"
                                class="w-full"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="vx-col sm:w-1/1 w-full">
            <div style="
                position: absolute;
                left: 50%;
                -ms-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
            ">
                <vs-button class="mr-3 mb-2" @click="handleUnreserve()">Unreserve</vs-button>
                <vs-button class="mr-3 mb-2" @click="handleMovement()">Movement</vs-button>
                <vs-button class="mr-3 mb-2" @click="handleCreateNewOutbound()">Create New</vs-button>
                <vs-button class="mr-3 mb-2" @click="handleCalculateDiscount()">Calculate Disc</vs-button>
            </div>
        </div>
        <br>
    </vx-card>
</template>

<script>
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
    },
    data() {
        return {
            thePassword: "",
            code: "",
            outboundCode: "",
            movementOperation: "",
            returnType: [
                {
                    value: true,
                    name: "With reference",
                },
                {
                    value: false,
                    name: "Without reference",
                }
            ],
            selectedReturnType: {
                value: false,
                name: "",
            },
        }
    },
    mounted() {
        this.selectedReturnType = this.returnType[0]
    },
    methods: {
        handleUnreserve() {
            if (this.thePassword == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank key password",
                    text: "Please fill the password",
                });
                return false;
            }

            if (this.code == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank document code (not GRR)",
                    text: "Please fill document code (not GRR)",
                });
                return false;
            }

            let params = {
                password: this.thePassword,
                code: this.code,
                outbound_code: "",
                type: this.selectedReturnType.value,
                operation: "unreserve",
            }

            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to unreserve this document?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("/api/wms/v1/wms/purchase/po-return/emergency-movement", params)
                    .then(resp => {
                        if (resp.code == 200) {
                            console.log("unreserved")
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "success",
                                title: "Unreserve data",
                                text: resp.message,
                            })
                        } else {
                            console.log("error unreserved => ", resp.message)
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            });
        },
        handleMovement() {
            if (this.thePassword == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank key password",
                    text: "Please fill the password",
                });
                return false;
            }

            if (this.code == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank document code (not GRR)",
                    text: "Please fill document code (not GRR)",
                });
                return false;
            }

            if (this.outboundCode == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank outbound document code (not GRR)",
                    text: "Please fill outbound document code (not GRR)",
                });
                return false;
            }

            if (this.movementOperation == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank movement operation",
                    text: "Please fill movement operation",
                });
                return false;
            }

            let params = {
                password: this.thePassword,
                code: this.code,
                outbound_code: this.outboundCode,
                type: this.selectedReturnType.value,
                movement_operation: this.movementOperation,
                operation: "stock-movement",
            }

            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to force movement stock this document?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("/api/wms/v1/wms/purchase/po-return/emergency-movement", params)
                    .then(resp => {
                        if (resp.code == 200) {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "success",
                                title: "Stock movement",
                                text: resp.message,
                            })
                        } else {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            });
        },
        handleCreateNewOutbound() {
            if (this.thePassword == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank key password",
                    text: "Please fill the password",
                });
                return false;
            }

            if (this.code == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank document code (not GRR)",
                    text: "Please fill document code (not GRR)",
                });
                return false;
            }

            if (this.outboundCode == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank outbound document code (not GRR)",
                    text: "Please fill outbound document code (not GRR)",
                });
                return false;
            }

            let params = {
                password: this.thePassword,
                code: this.code,
                outbound_code: this.outboundCode,
                type: this.selectedReturnType.value,
                operation: "new-outbound-doc",
            }

            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to force create new outbound document if this is partial?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("/api/wms/v1/wms/purchase/po-return/emergency-movement", params)
                    .then(resp => {
                        if (resp.code == 200) {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "success",
                                title: "Create new document",
                                text: resp.message,
                            })
                        } else {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            });
        },
        handleCalculateDiscount() {
            if (this.thePassword == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank key password",
                    text: "Please fill the password",
                });
                return false;
            }

            if (this.code == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank document code (not GRR)",
                    text: "Please fill document code (not GRR)",
                });
                return false;
            }

            if (this.outboundCode == "") {
                this.$vs.dialog({
                    color: "danger",
                    title: "Blank outbound document code (not GRR)",
                    text: "Please fill outbound document code (not GRR)",
                });
                return false;
            }

            if (!this.selectedReturnType.value) {
                this.$vs.dialog({
                    color: "danger",
                    title: "Wrong type",
                    text: "With refs only",
                });
                return false;
            }

            let params = {
                password: this.thePassword,
                code: this.code,
                outbound_code: this.outboundCode,
                type: this.selectedReturnType.value,
                operation: "calculate-discount",
            }

            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to force calculate discount of this document?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post("/api/wms/v1/wms/purchase/po-return/emergency-movement", params)
                    .then(resp => {
                        if (resp.code == 200) {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "success",
                                title: "Calculate discount",
                                text: resp.message,
                            })
                        } else {
                            this.$vs.loading.close();
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });
                }
            });
        }
    }
}
</script>